/**
 * The default task for poster uploads
 */
export const POSTER_FILE_UPLOAD_DEFAULT_TASK = 'piivo-poster-upload';

/**
 * The name of the form action for poster uploads (without prefix)
 */
export const POSTER_UPLOAD_FORM_ACTION = 'upload';
